var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.281,
    height: 35.07,
    viewBox: "0 0 28.281 35.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WORD_V2",
    transform: "translate(-221 -176.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M312.349,220.849H288.24V186.86h19.41l4.7,4.039Z",
    transform: "translate(-63.608 -9.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241_-_Outline",
    "data-name": "Path 241 - Outline",
    d: "M302.889,211.93H278.78a.54.54,0,0,1-.54-.54V177.4a.54.54,0,0,1,.54-.54h19.41a.54.54,0,0,1,.352.131l4.7,4.039a.54.54,0,0,1,.188.41v29.95A.54.54,0,0,1,302.889,211.93Zm-23.569-1.08h23.029V181.687l-4.36-3.747H279.32Z",
    transform: "translate(-54.148)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M642.83,187.455H639.8a2.217,2.217,0,0,1-2.215-2.215v-2.38a.54.54,0,1,1,1.08,0v2.38a1.136,1.136,0,0,0,1.134,1.134h3.025a.54.54,0,1,1,0,1.08Z",
    transform: "translate(-394.089 -5.165)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_30",
    "data-name": "Line 30",
    d: "M5.139-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h14.6a.54.54,0,0,1,.54.54A.54.54,0,0,1,5.139-8.92Z",
    transform: "translate(238.883 193.356)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_31",
    "data-name": "Line 31",
    d: "M5.139-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h14.6a.54.54,0,0,1,.54.54A.54.54,0,0,1,5.139-8.92Z",
    transform: "translate(238.883 196.822)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_32",
    "data-name": "Line 32",
    d: "M5.139-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h14.6a.54.54,0,0,1,.54.54A.54.54,0,0,1,5.139-8.92Z",
    transform: "translate(238.883 200.288)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_33",
    "data-name": "Line 33",
    d: "M-2.21-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h7.25a.54.54,0,0,1,.54.54A.54.54,0,0,1-2.21-8.92Z",
    transform: "translate(246.232 203.754)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_34",
    "data-name": "Line 34",
    d: "M-2.21-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h7.25a.54.54,0,0,1,.54.54A.54.54,0,0,1-2.21-8.92Z",
    transform: "translate(246.232 207.219)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_35",
    "data-name": "Line 35",
    d: "M-2.21-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h7.25a.54.54,0,0,1,.54.54A.54.54,0,0,1-2.21-8.92Z",
    transform: "translate(246.232 210.685)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_36",
    "data-name": "Line 36",
    d: "M-2.21-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h7.25a.54.54,0,0,1,.54.54A.54.54,0,0,1-2.21-8.92Z",
    transform: "translate(246.232 214.151)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1338",
    "data-name": "Rectangle 1338",
    width: 12.221,
    height: 12.57,
    transform: "translate(221.698 193.375)",
    fill: "#1d7bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1338_-_Outline",
    "data-name": "Rectangle 1338 - Outline",
    d: "M-9.46-10H3.071a.54.54,0,0,1,.54.54V3.071a.54.54,0,0,1-.54.54H-9.46a.54.54,0,0,1-.54-.54V-9.46A.54.54,0,0,1-9.46-10ZM2.531-8.92H-8.92V2.531H2.531Z",
    transform: "translate(231 202.747)",
    fill: "#1d7bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M269.991,552.289l-1.609-5.48c-.033-.082.008-.139.1-.139h1.086a.125.125,0,0,1,.139.1l1.045,3.855,1.143-3.855a.125.125,0,0,1,.139-.1h1a.125.125,0,0,1,.139.1l1.143,3.855,1.045-3.855a.125.125,0,0,1,.139-.1H276.6c.09,0,.123.057.1.139l-1.617,5.48a.157.157,0,0,1-.163.1h-1.086c-.082,0-.147-.032-.163-.1l-1.127-3.986-1.135,3.986c-.016.065-.082.1-.163.1h-1.086a.157.157,0,0,1-.163-.1Z",
    transform: "translate(-44.812 -349.835)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordDocument);
export default __webpack_public_path__ + "static/media/word-document.c11572ef48ce5fff58613f4a512aea45.svg";
export { ForwardRef as ReactComponent };